import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
type TooltipActionType = 'open' | 'close';
const getAnalyticsDriverActionName = (driverLabel: string) => {
  return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(' ').join('')}`;
};
export function useMonetizingTooltipPageAction() {
  const $ = _c(4);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      actionName: "",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[2] !== firePageAction) {
    t1 = (driverLabel, actionType, actionSection) => {
      firePageAction({
        action_name: `${getAnalyticsDriverActionName(driverLabel)}`,
        action_type: actionType,
        action_section: actionSection
      });
    };
    $[2] = firePageAction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function useNonMonetizingTooltipPageAction(offerId) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function getAnalyticsDriverActionName(driverLabel) {
      return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(" ").join("")}`;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const getAnalyticsDriverActionName = t0;
  let t1;
  if ($[1] !== offerId) {
    t1 = {
      actionName: "",
      additionalAttributes: {
        sku_id: offerId
      }
    };
    $[1] = offerId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const firePageAction = usePageAction(t1);
  let t2;
  if ($[3] !== firePageAction) {
    t2 = (driverLabel_0, actionType, actionSection) => {
      firePageAction({
        action_name: `${getAnalyticsDriverActionName(driverLabel_0)}`,
        action_type: actionType,
        action_section: actionSection
      });
    };
    $[3] = firePageAction;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}